export default {
  steps: {
    0: {
      title: 'Bądź stałym klientem',
      description: 'Przeglądaj historię zamówień i zamawiaj ponownie jednym dotknięciem.',
    },
    1: {
      title: 'Zdobywaj nagrody',
      description: 'Śledź swoje punkty i wymieniaj zgromadzone nagrody z portfela.',
    },
    2: {
      title: 'Zamów z wyprzedzeniem',
      description: 'Znajdź najbliższy lokal i złóż zamówienie szybciej niż kiedykolwiek.',
    },
  },
  buttons: {
    skip: 'Pomiń',
  },
};
